// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.ios {
	min-height: 150px;
}
`, "",{"version":3,"sources":["webpack://./../confluence-editor/src/editor-plugins/iosediting/iosediting.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;AAClB","sourcesContent":["body.ios {\n\tmin-height: 150px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
